import gql from 'graphql-tag';

export default gql`
  fragment formFieldFragment on FormField {
    id
    type
    name
    title
    labelSize
    description
    required
    value
    placeholder
    dataType
    attributes {
      key
      value
    }
    data {
      key
      value
    }
    options {
      value
      title
      selected
      disabled
    }
  }
`;
